<template>
  <div v-if="!isLoading" class="setup">
    <div v-if="this.exists">
      <h3>Your public url:</h3>
      <router-link :to="profileUrl" target="_blank">{{
        this.fullUrl
      }}</router-link>
      <br /><br />
    </div>
    <h3>Add your app info:</h3>
    <p>
      *App name:
      <input type="text" v-model="appName" placeholder="Some app info" /><br />
    </p>
    <p>
      Link: <input type="text" v-model="link" placeholder="https://..." /><br />
    </p>
    <p>Marketing info:</p>
    <textarea
      v-model="marketing"
      placeholder="This app does a lot of things..."
    ></textarea
    ><br />
    <p>Contact info:</p>
    <textarea v-model="contact" placeholder="Call me at 555-..."></textarea
    ><br />
    <p>Privacy policy:</p>
    <textarea
      v-model="pp"
      placeholder="We sell every scrap of data we have on you..."
    ></textarea
    ><br />
    <button :disabled="isSaving" @click="save">Save</button>
    <br /><br /><br />
    <button @click="logout">Log out</button>
  </div>
  <div v-else>loading...</div>
</template>

<script>
import firebase from "firebase";
import { database } from "../main";
export default {
  name: "Setup",
  data() {
    return {
      id: "",
      isLoading: true,
      isSaving: false,
      exists: false,
      appName: "",
      link: "",
      marketing: "",
      contact: "",
      pp: "",
    };
  },
  computed: {
    profileUrl: function () {
      return "app/" + this.id;
    },
    fullUrl: function () {
      return "https://someapp.info/" + this.profileUrl;
    },
  },
  methods: {
    save: function () {
      if (this.appName.length == 0) {
        alert("You need an app name..");
        return;
      }

      this.isSaving = true;
      database
        .collection("users")
        .doc(this.id)
        .set({
          name: this.appName,
          url: this.link,
          marketing: this.marketing,
          contact: this.contact,
          pp: this.pp,
        })
        .then(() => {
          alert("App updated");
          this.isSaving = false;
          this.exists = true;
        })
        .catch(function (error) {
          alert("Oops: " + error.message);
          this.isSaving = false;
        });
    },
    logout: function () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    },
  },
  created: function () {
    this.id = firebase.auth().currentUser.uid;
    database
      .collection("users")
      .doc(this.id)
      .get()
      .then((doc) => {
        var data = doc.data();
        if (data) {
          this.exists = true;
          this.appName = data["name"];
          this.link = data["url"];
          this.marketing = data["marketing"];
          this.contact = data["contact"];
          this.pp = data["pp"];
        }

        this.isLoading = false;
      });
  },
};
</script>

<style scoped>
.login {
  margin-top: 40px;
}
input {
  padding: 5px;
}
textarea {
  min-width: 500px;
  min-height: 100px;
  padding: 5px;
}
</style>